const colors = {
    theme: '#000',
    yellow: 'var(--color-primary)',
    grey: "#ffffff12",
    blue: '#12296C',
    lightBlue: "#1281FF",
    green: "var(--color-second)",
    orangeGradient: "var(--color-second)",
    purple: " var(--color-ternary)",
    pink: "var(--color-primary)",
    blackPrimary: "#ffffff12",
    blackSecondary: "#c8c8c80f",
    blackTernary: "#0000004D",
    greyPrimary: "#898989",
    greySecondary: "#f8f8f812",
    greyTernary: '#ffffff14',
    blackDarkTheme: "#282828",
    blackDarkThemePrimary: "#252525",
    blackDarkThemeSecondary: "#232323",
    blackBlur5: '#00000080',
    greyQuaternary: '#AAAAAA',
    brownPrimary: '#4D3805',
    darkGreyPrimary: '#1e1e1e',
    newbgcolor: '#171717',
    darkGreySecondary: '#242424',
    darkGreyTernary: '#1a1a1a',
    darkGreyQuaternary: '#1b1b1b',
    lightGrey: '#EFEFEF',
    blackTransparent: "#000000d6",
    blackDark: '#191919',
    eccColor: ' #3560CA',
    moodyColor: '#37B9AB',
    moodyTestColor: '#42C7B2',
    aiChatColor: ' #0B1046',
    biteuColor: '#DCCB63',
    eccAppColor: '#2849B4',
    storyMagic: '#7F51D5'

};

export default colors;
